import {
  Button,
  ButtonAppearance,
  CustomImage,
  DisableFocusWrapper,
  TextAlignment,
  TextAppearance,
  Text,
  Richtext,
  CustomImageProps
} from '@vw-marketing/us-components';
import React from 'react';
import { AppConstants } from '../../../../utils/app-constants';
import {ContentWrapper, StateWrapper} from '../styled';
import { descriptionSuccessTextStyle} from './helpers';
import {HeaderWrapper, ImageWrapper, TextWrapper} from './styled';

export interface SuccessConfiguration {
  headerLabel?: string;
  description?: string;
  buttonCtaLabel?: string;
  image: CustomImageProps;
}
interface SuccessViewProps {
  okHandler: () => void;
  inline?: boolean;
  contentConfiguration?: SuccessConfiguration;
  faHostServer?: string;
}

export const SuccessView = ({
  okHandler,
  inline,
  contentConfiguration,
  faHostServer
}: SuccessViewProps) => {

  const DEFAULT_CONTENT_CONFIG =  {
    headerLabel: 'Thank you for contacting us!',
    description:
      '<p>We have received your message. <br /> <br /> Our team will contact you as soon as possible to give you the information you need.</p>',
    buttonCtaLabel: 'Okay',
    image: {
      src: '',
      srcPlaceholder: AppConstants.PlaceHolder480x216,
      srcErrorImage: faHostServer+AppConstants.Ngw6Logo480x216,
      alt: ''
    }
  };

  const successContent: SuccessConfiguration =
    (contentConfiguration && {
      ...DEFAULT_CONTENT_CONFIG,
      ...contentConfiguration
    }) ||
    DEFAULT_CONTENT_CONFIG;

  return (
    <StateWrapper inline={inline} className="success-view-wrapper">
      <ContentWrapper inline={inline}>
        <HeaderWrapper className='success-view-header'>
          <Text
            appearance={TextAppearance.headline300}
            bold
            textAlign={TextAlignment.center}
          >
            {successContent?.headerLabel || ``}
          </Text>
        </HeaderWrapper>
        <TextWrapper>
          <Richtext
            markdown={successContent?.description || ''}
            overrides={descriptionSuccessTextStyle}
            dangerouslyParseRawHTML
          />
        </TextWrapper>
        <ImageWrapper>
          <CustomImage {...successContent.image} />
        </ImageWrapper>
        <DisableFocusWrapper>
          <Button appearance={ButtonAppearance.Primary} onClick={okHandler}>
            {successContent.buttonCtaLabel}
          </Button>
        </DisableFocusWrapper>
      </ContentWrapper>
    </StateWrapper>
  );
};
